module Meevo.Plugins.PaymentPlans {
    export class PaymentPlansApi {

        static factory(): Function {
            const instance = (dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new PaymentPlansApi(dataService);
            };

            instance.$inject = [
                'meevo.components.common.DataService'
            ];

            return instance;
        }

        constructor(private _dataService: Meevo.Components.BaseClasses.IDataService) {
        }

        getPaymentPlansList(criteria: IPaymentPlanSearchCriteria): ng.IPromise<IPaymentPlanListItem[]> {
            return this._dataService.getListPaged(`PaymentPlan`, {
                pageNumber: 0,
                itemsPerPage: 1000,
                criteria,
            });
        }
    }


    angular.module('meevo.plugins.paymentPlans')
        .service('meevo.plugins.paymentPlans.PaymentPlansApi', PaymentPlansApi.factory());
}
